// extracted by mini-css-extract-plugin
export default {"label":"LabelWithArrow_label__Jq4Gw","iconWrapper":"LabelWithArrow_iconWrapper__a4xRJ","icon":"LabelWithArrow_icon__BKL9A"};